import emailValidator from "email-validator";
import compareAsc from "date-fns/compareAsc";

import React from "react";

export const required = (value) =>
  value ? undefined : "This field is required";

export const email = (value) =>
  value && !emailValidator.validate(value)
    ? "Emails must have both an @ and domain (e.g. .com)"
    : undefined;

export const checkTime = (values) => {
  const errors = {};

  if (compareAsc(values.startTime, values.endTime) === 1) {
    errors.endTime = "End Time cannot be earlier than Start Time";
    return errors;
  }
};

export const checkTemp = (value) => {
  return value < 0 || value > 99 ? '2 digits or less' : undefined
}

export const confirmEmail = (emailFieldValue, confirmEmailValue) =>
  emailFieldValue === confirmEmailValue
    ? undefined
    : "validation.confirmNotEqual";

export const measurementRange = (range) => (value) =>
  (value && value !== "0.00" && parseFloat(value) < range[0]) ||
  (value && value !== "0.00" && parseFloat(value) > range[1])
    ? `Enter values between ${range[0]} and ${range[1]}`
    : undefined;

export const valueIsNumber = (value) =>
  value && isNaN(parseFloat(value))
    ? "Please only use numbers and period. E.g. 100.0"
    : undefined;

export const maxLength = (length) => (value) =>
  value && value.length === length
    ? `Maximum ${length} characters.`
    : undefined;

export const composeValidators = (...validators) => (value) =>
  validators.reduce((error, validator) => error || validator(value), undefined);

/**
 * Password requirements
 * @returns
 * - {bool} if password is valid
 * - {arr} array of errors if invalid
 */
export function passwordValid(password) {
  let errors = [];

  if (!password) {
    errors.push(<li>Password is required.</li>);
  } else {
    // minimum 8 characters
    if (password.length < 8) {
      errors.push(<li>Password must be 8 or more characters.</li>);
    }

    // at least 1 uppercase character
    if (!/([A-Z]+)/g.test(password)) {
      errors.push(<li>Password must have at least 1 uppercase character.</li>);
    }

    // at least 1 special character
    if (!/([!@#$%^&*(),.?":{}|<>]+)/g.test(password)) {
      errors.push(<li>Password must have at least 1 special character.</li>);
    }
  }

  if (errors.length >= 1) {
    return errors;
  }

  return undefined;
}

/**
 * Passwords match?
 * @returns
 * - {bool} if password is valid
 * - {str} error string if invalid
 */
export function passwordsMatch({ password='', passwordConfirmation='' }) {
  const errors = {};

  if (password !== passwordConfirmation) {
    errors.passwordConfirmation = "Your passwords do not match.";
    return errors;
  }
  return undefined;
}



// WEBPACK FOOTER //
// ./src/helpers/formValidators.js